import styled, { css } from 'styled-components';
import React from 'react';
import { layout } from 'app_previous/styles/layout';
import { HeadingContentfulModel } from 'src/api/models/Heading';
import Heading from 'app_previous/elements/typography/heading';

interface DynamicHeadingContainerProps {
  breakpoint?: string;
  breakpointFontSize?: number;
  maxWidth?: string;
}

const DynamicHeadingContainer = styled.div<DynamicHeadingContainerProps>`
  display: grid;
  justify-self: center;
  box-sizing: border-box;
  padding: 0 10px;
  margin-bottom: 2rem;

  ${({ maxWidth }) =>
    !maxWidth
      ? ''
      : css`
          max-width: ${maxWidth};
        `}

  ${({ breakpointFontSize, breakpoint }) =>
    !breakpointFontSize
      ? ''
      : css`
          @media all and (max-width: ${breakpoint}) {
            h1 {
              font-size: ${breakpointFontSize}px;
            }
          }
        `}
`;

export default function getDynamicHeading(headingProps: HeadingContentfulModel): React.ReactNode {
  return (
    <DynamicHeadingContainer
      breakpoint={headingProps.responsiveBreakpoint ?? layout.sm}
      breakpointFontSize={headingProps.responsiveFontSize}
      maxWidth={headingProps.maximumWidth}
    >
      <Heading
        text={headingProps.text}
        size={headingProps.size ? `${headingProps.size}px` : '3.125rem'}
        align={headingProps.textAlign ?? 'center'}
        color={headingProps.color}
      />
    </DynamicHeadingContainer>
  );
}
